import React from 'react';
import { Icon } from './Icon.js';
export const IconClipboardCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4 5V22H20V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 2.5V6H16V2.5L15.5112 2.31671C13.2474 1.46777 10.7526 1.46777 8.48877 2.31671L8 2.5Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M8.5 14.5L10.5 16.5L15.5 11.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconClipboardCheck.js.map